//File imports
import {
    PAGINATION_DEFAULT_LIMIT,
    PAGINATION_DEFAULT_PAGE,
} from '../../../Constant';
import HttpService from '../../../services/Http/HttpService';
import Logger from '../../../services/Logger/Logger';
import { API_GET_ALL_SUCCESS_DOCUMENTS, API_SEND_DOCUMENT_EMAIL } from './DocumentConstants';
import DraftResultsPojo from './DocumentResultPojo';

export class DocumentService {
    private httpService = new HttpService();
    private logger = new Logger();

    async getAllWithPagination(
        page: number = PAGINATION_DEFAULT_PAGE,
        limit: number = PAGINATION_DEFAULT_LIMIT,
        showDevDrafts: boolean = false,
    ): Promise<DraftResultsPojo> {
        try {
            const httpResult = await this.httpService.get(
                API_GET_ALL_SUCCESS_DOCUMENTS,
                {
                    page: page,
                    limit: limit,
                    showDevDrafts: showDevDrafts,
                },
            );
            return {
                isSuccess: httpResult.data.isSuccess,
                documents: httpResult.data.response,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async sendDocumentEmail(uniqueId: string, email: string): Promise<any> {
        try {
            const httpResult = await this.httpService.post(
                API_SEND_DOCUMENT_EMAIL,
                { uniqueId, email }
            );
            return httpResult.data;
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }
}
